module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxupRBTtN4E2_qSPBnw6AgMc.woff2";